const Table1 = ({ details }) => {
	return (
		<table className="approved assigned">
			<thead>
				<tr>
					<th>Name</th>
					<th>Email</th>
					<th>Phone</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td className="center">{details.name}</td>
					<td className="center">
						<a href={`mailto:${details.email}`}>{details.email}</a>
					</td>
					<td className="center">{details.phone}</td>
				</tr>

				<tr>
					<td
						className="center"
						colSpan="3"
						style={{
							paddingTop: "12.5px",
							paddingBottom: "12.5px",
						}}
					>
						<a
							href={`https://valerotexasopen.com/benefit-for-children/guest/${details.id}`}
							target="_blank"
							rel="noopener noreferrer"
						>
							Guest Registration Access&nbsp;&nbsp;
							<i className="fa fa-external-link" />
						</a>
					</td>
				</tr>
			</tbody>
		</table>
	);
};

export default Table1;
